<template>
  <el-container type="flex" class="main_container">
    <base-header>商品上新</base-header>
    <personal-form></personal-form>
  </el-container>
</template>

<script>
import PersonalForm from '../common/PersonalForm'

export default {
  name: 'NewGood',
  components: { PersonalForm }
}
</script>
